import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("title4", component(opts));
  editor.BlockManager.add("title4", block(opts));
};